<template>
    <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_5296_31047)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.90503 10.8439H5.90576L5.90759 10.8437H14.4062C14.6155 10.8437 14.7994 10.705 14.8569 10.5038L16.7319 3.94128C16.7723 3.7998 16.744 3.6477 16.6555 3.53027C16.5669 3.41284 16.4283 3.34375 16.2812 3.34375H4.82397L4.48889 1.83582C4.44116 1.62134 4.25097 1.46875 4.03125 1.46875H1.21875C0.959839 1.46875 0.75 1.67859 0.75 1.9375C0.75 2.19641 0.959839 2.40625 1.21875 2.40625H3.65527L5.34765 10.0222C4.84948 10.2388 4.5 10.7355 4.5 11.3125C4.5 12.0879 5.13086 12.7187 5.90625 12.7187H14.4062C14.6652 12.7187 14.875 12.5089 14.875 12.25C14.875 11.9911 14.6652 11.7812 14.4062 11.7812H5.90625C5.64782 11.7812 5.4375 11.5709 5.4375 11.3125C5.4375 11.0544 5.64709 10.8445 5.90503 10.8439ZM15.6598 4.28125L14.0526 9.90625H6.28222L5.03222 4.28125H15.6598ZM5.4375 14.125C5.4375 14.9004 6.06836 15.5312 6.84375 15.5312C7.61914 15.5312 8.25 14.9004 8.25 14.125C8.25 13.3496 7.61914 12.7188 6.84375 12.7188C6.06836 12.7188 5.4375 13.3496 5.4375 14.125ZM6.84375 13.6562C7.10217 13.6562 7.3125 13.8666 7.3125 14.125C7.3125 14.3834 7.10217 14.5937 6.84375 14.5937C6.58533 14.5937 6.375 14.3834 6.375 14.125C6.375 13.8666 6.58533 13.6562 6.84375 13.6562ZM13.4687 15.5312C12.6934 15.5312 12.0625 14.9004 12.0625 14.125C12.0625 13.3496 12.6934 12.7188 13.4687 12.7188C14.2441 12.7188 14.875 13.3496 14.875 14.125C14.875 14.9004 14.2441 15.5312 13.4687 15.5312ZM13.9375 14.125C13.9375 13.8666 13.7272 13.6562 13.4687 13.6562C13.2103 13.6562 13 13.8666 13 14.125C13 14.3834 13.2103 14.5937 13.4687 14.5937C13.7272 14.5937 13.9375 14.3834 13.9375 14.125Z"
                fill="#48E4FF"
            />
        </g>
        <defs>
            <clipPath id="clip0_5296_31047">
                <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0.75 0.5)"
                />
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
